var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('md-switch',{staticClass:"md-primary",on:{"change":function($event){return _vm.$emit('input', _vm.modelValue)}},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }